import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "create-post-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "点击上传头像", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border text-secondary",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading ...")
  ]),
  /*#__PURE__*/_createElementVNode("h2", null, "正在上传")
], -1)
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "文章标题：", -1)
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "文章详情：", -1)
const _hoisted_9 = { class: "btn btn-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Uploader = _resolveComponent("Uploader")!
  const _component_validate_input = _resolveComponent("validate-input")!
  const _component_Validate_form = _resolveComponent("Validate-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", null, _toDisplayString(_ctx.isEditMode ? '编辑文章' : '新建文章'), 1),
    _createVNode(_component_Uploader, {
      class: "d-flex align-items-center justify-content-center bg-light text-secondary w-100 my-4",
      beforeUpload: _ctx.uploadCheck,
      onFileUploaded: _ctx.handleFileUploaded,
      action: "/upload",
      UpLOadedData: _ctx.UpLOadedData
    }, {
      loading: _withCtx(() => [
        _hoisted_3
      ]),
      uploaded: _withCtx((dataProps) => [
        _createElementVNode("img", {
          src: dataProps.uploadedData.data?.url
        }, null, 8, _hoisted_4)
      ]),
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["beforeUpload", "onFileUploaded", "UpLOadedData"]),
    _createVNode(_component_Validate_form, {
      onFormSubmit: _ctx.onFormSubmit,
      class: "from"
    }, {
      submit: _withCtx(() => [
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.isEditMode ? '更新文章' : '发布文章'), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_validate_input, {
            type: "email",
            placeholder: "请输入文章标题",
            rules: _ctx.titleRules,
            modelValue: _ctx.titleVal,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.titleVal) = $event)),
            ref: "inputRef"
          }, null, 8, ["rules", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_validate_input, {
            rows: "10",
            type: "text",
            tag: "textarea",
            placeholder: "请输入文章详情",
            rules: _ctx.contentRules,
            modelValue: _ctx.contentVal,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contentVal) = $event))
          }, null, 8, ["rules", "modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["onFormSubmit"])
  ]))
}